import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: index,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        meta: { title: '首页' }
      },
      {
        path: '/AI',
        name: 'AI',
        component: () => import('../views/AI/index.vue'),
        meta: { title: 'AI' }
      },
      {
        path: '/AIMenu',
        name: 'AIMenu',
        component: () => import('../views/AI/indexb.vue'),
        meta: { title: 'AIMenu' }
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('../views/product/index.vue'),
        meta: { title: '产品' }
      },
      {
        path: '/app',
        name: 'app',
        component: () => import('../views/app/index.vue'),
        meta: { title: '应用' }
      },
      {
        path: '/solution',
        name: 'solution',
        component: () => import('../views/solution/index.vue'),
        meta: { title: '解决方案' }
      },
      {
        path: '/crmcase',
        name: 'crmcase',
        component: () => import('../views/crmcase/index.vue'),
        meta: { title: '客户案例' }
      },
      {
        path: '/crmcaseinfo',
        name: 'crmcaseinfo',
        component: () => import('../views/crmcaseinfo/index.vue'),
        meta: { title: '案例详情' }
      },
      {
        path: '/aboutus',
        name: 'aboutus',
        component: () => import('../views/aboutus/index.vue'),
        meta: { title: '关于我们' }
      },
      {
        path: '/contactForm',
        name: 'contactForm',
        component: () => import('../views/contactForm/index.vue'),
        meta: { title: '联系表单' }
      }
    ]
  }
  // {
  //   path: '/mwzb',
  //   name: 'Mwzb',
  //   component: () => import('../views/form/mwzb.vue'),
  //   meta: { title: '门卫值班' }
  // }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
